import styled from 'styled-components';

import DefaultSelectMenu from 'components/selectMenu/DefaultSelectMenu';
import DefaultButton from 'components/button/DefaultButton';

import { useMutation } from '@tanstack/react-query';
import { restfetcher } from 'queryClient';
import { useState } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import modalInformationAtom from 'atom/modalInformationAtom';
import { message } from 'antd';
import userInforAtom from 'atom/userInfoAtom';

interface ChoiceMembershipProps {
  index: number;
  devicesInfo: DevicesInfo[];
  defaultMembership: DefaultMembership | null;
  membershipInfo: MembershipInfo[];
}

const ChoiceMembership = ({
  index,
  devicesInfo,
  defaultMembership,
  membershipInfo
}: ChoiceMembershipProps) => {
  const initialString = '멤버십을 선택하여주세요.';
  const [messageApi, contextHolder] = message.useMessage();

  const userInfor = useAtomValue(userInforAtom);

  const [newSelectedOption, setNewSelectedOption] = useState(membershipInfo[index]?.membershipidx);
  const setModalInformation = useSetAtom(modalInformationAtom);

  const handleLabelValue = () => {
    const newArray: {
      label: string;
      value: number;
    }[] = [];
    const membershipList = membershipInfo;

    membershipList?.forEach((data: MembershipInfo) => {
      newArray.push({
        label: data.ticketname,
        value: data.membershipidx
      });
    });

    return newArray;
  };

  const editMembership = useMutation({
    mutationFn: (params: any) =>
      restfetcher({
        method: 'POST',
        path: 'biz/my/membership/device/membership/save',
        params: params
      }),

    onSuccess: () => {
      messageApi.info({
        type: 'success',
        content: '적용되었습니다.',
        style: {
          marginTop: '10vh'
        }
      });
    }
  });

  const editIsValidMembership = useMutation({
    mutationFn: (params: any) =>
      restfetcher({
        method: 'POST',
        path: 'biz/my/membership/device/check',
        params: params
      }),

    onSuccess: (data: any) => {
      if (data.result === 'success' && !data.deviceidx) {
        const params = {
          usridx: userInfor.usridx,
          deviceidx: devicesInfo[index]?.deviceidx,
          membershipidx: newSelectedOption
        };

        editMembership.mutate(params);
      } else if (data.result === 'success' && data.deviceidx !== devicesInfo[index]?.deviceidx) {
        setModalInformation({
          type: 'CHECK_MEMBERSHIP',

          handleClickRightBtn: () => {
            const params = {
              usridx: userInfor.usridx,
              deviceidx: devicesInfo[index]?.deviceidx,
              membershipidx: newSelectedOption
            };

            editMembership.mutate(params);
          }
        });
      }
    }
  });

  const handleClickEditMembershipName = () => {
    const params = {
      usridx: userInfor.usridx,
      membershipidx: newSelectedOption
    };

    editIsValidMembership.mutate(params);
  };

  const handleChoiceSelectBox = (data: string | number) => {
    const selectedType = membershipInfo.find(
      (item: MembershipInfo) => item?.membershipidx === data
    );
    if (selectedType) {
      setNewSelectedOption(selectedType.membershipidx);
    }
  };

  return (
    <Wrapper>
      <DefaultSelectMenu
        defaultValue={defaultMembership?.ticketname ? defaultMembership?.ticketname : undefined}
        placeholder={initialString}
        options={handleLabelValue()}
        onChange={(newData) => handleChoiceSelectBox(newData)}
      />
      <DefaultButton
        text="적용"
        size="small"
        type="primary"
        onClick={() => handleClickEditMembershipName()}
      />
      {contextHolder}
    </Wrapper>
  );
};

export default ChoiceMembership;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  .ant-select {
    min-width: 267px;

    .ant-select-selection-item {
      font-size: 14px;
    }
  }
`;
